var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 768,
    viewBox: "0 0 1366 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 1366,
    height: 768,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_17",
    "data-name": "Mask Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1366,
    height: 768,
    fill: "#eae8f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 690.884,
    height: 943,
    transform: "translate(651.474 -1.106) rotate(-16)",
    fill: "#f4f5f7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground01);
export default __webpack_public_path__ + "static/media/background_01.432941d5235cd7b787aecbcd63e7b69e.svg";
export { ForwardRef as ReactComponent };